<template>
  <card class="card" title="Dados da Movimentação do Carro">
    <div>
      <form>
        <div class="row">
          <div class="col-md-5">
            <fg-input
              type="text"
              label="Nome do Motorista"
              :value="carTransfer ? carTransfer.driver.name : ''"
              readonly
            ></fg-input>
          </div>
          <div class="col-md-3">
            <fg-input type="text" label="Marca" :value="carTransfer ? carTransfer.car.manufacturer : ''" readonly></fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text" label="Modelo" :value="carTransfer ? carTransfer.car.model : ''" readonly></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
              <fg-input type="text" label="Placa" :value="carTransfer ? carTransfer.car.plate : ''" readonly></fg-input>
          </div>

          <div class="col-md-4">
              <fg-input type="text" label="Km" :value="carTransfer ? carTransfer.mileage : ''" readonly></fg-input>
          </div>

          <div class="col-md-4">
            <fg-input type="text" label="Data" :value="carTransfer ? formatDate(new Date(carTransfer.createdAt)) : ''" readonly></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Descrição</label>
              <textarea
                rows="5"
                class="form-control border-input"
                :value="carTransfer ? carTransfer.description : ''"
                readonly
              ></textarea>
            </div>
          </div>
        </div>

        <div class="clearfix"></div>
      </form>
    </div>
    <div class="app-container">
      <div id="lightgallery">
        <a v-for="image in carTransfer ? carTransfer.images : []" :key="image.id" :href="`https://api.globalfibra.com.br/app/car-transfer-uploads/${image.filename}`">
          <img height="200" width="200" :src="`https://api.globalfibra.com.br/app/car-transfer-uploads/${image.filename}`" >
        </a>
      </div>
    </div>
  </card>
</template>

<script>
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import { mapActions } from "vuex";

export default {
  name: 'IssueDetail',
  data() {
    return {
      carTransfer: null,
      imageList: []
    }
  },
  watch: {
    carTransfer: function () {
      this.$nextTick(function () {
        const el = document.getElementById("lightgallery");
        window.lgData[el.getAttribute("lg-uid")].destroy();
        window.lightGallery(el, {
          speed: 500,
        });
      });
    },
  },
  methods: {
    ...mapActions(["fetchCarTransfer"]),
    formatDate(date) {
      return formatDistance(date, new Date(), {
        locale: pt,
        addSuffix: true,
      });
    }
  },
  async mounted() {
    const el = document.getElementById("lightgallery");
    window.lightGallery(el, {
      speed: 500,
    });
    try {
      this.carTransfer = await this.fetchCarTransfer({ id: this.$route.params.id })
    } catch (e) {
      Swal.fire("Ops!", "Não foi possível carregar as informações", "error");
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }
}
</style>
